import { render } from "./WhatsAppSvg.vue?vue&type=template&id=86c46d1c"
import script from "./WhatsAppSvg.vue?vue&type=script&lang=js"
export * from "./WhatsAppSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__